import { render, staticRenderFns } from "./ToolbarContainer.vue?vue&type=template&id=3120df14&scoped=true&"
import script from "./ToolbarContainer.vue?vue&type=script&lang=js&"
export * from "./ToolbarContainer.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ToolbarContainer.vue?vue&type=style&index=1&id=3120df14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120df14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3120df14')) {
      api.createRecord('3120df14', component.options)
    } else {
      api.reload('3120df14', component.options)
    }
    module.hot.accept("./ToolbarContainer.vue?vue&type=template&id=3120df14&scoped=true&", function () {
      api.rerender('3120df14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToolbarContainer.vue"
export default component.exports